import React from 'react';
import './InfoModal.css';

interface InfoModalProps {
  title: string;
  content: {
    what: string;
    how: string;
    precedence: string;
  };
  isOpen: boolean;
  onClose: () => void;
}

const InfoModal: React.FC<InfoModalProps> = ({ title, content, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="info-modal-backdrop" onClick={onClose} />
      <div className="info-modal">
        <div className="info-modal-header">
          <h2>{title}</h2>
          <button 
            className="info-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            ✕
          </button>
        </div>
        
        <div className="info-modal-body">
          <div className="info-modal-section">
            <h3>What they are</h3>
            <p>{content.what}</p>
          </div>
          
          <div className="info-modal-section">
            <h3>How they're used</h3>
            <p>{content.how}</p>
          </div>
          
          <div className="info-modal-section">
            <h3>Precedence</h3>
            <p>{content.precedence}</p>
          </div>
        </div>
        
        <div className="info-modal-footer">
          <button className="info-modal-button" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </>
  );
};

export default InfoModal;